import React from 'react';
import { useTranslation } from 'react-i18next';
import { QButton } from '@qualio/ui-components';
import { useNavigate } from 'react-router-dom';
import { Form } from '../../../../types';

type HeaderEditButtonProps = {
  data: Form;
  shouldShowActionButton: boolean;
  isDisabled: boolean;
};

export const HeaderEditButton: React.FC<HeaderEditButtonProps> = ({
  data,
  shouldShowActionButton = false,
  isDisabled = false,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const shouldShowEditButton = ['draft'].includes(data.status) && shouldShowActionButton;

  return shouldShowEditButton ? (
    <QButton
      aria-label="edit"
      data-cy="edit"
      variant="outline"
      leftIcon="Edit3"
      isDisabled={isDisabled}
      onClick={() => navigate('edit')}
    >
      {t('common.actions.edit')}
    </QButton>
  ) : null;
};
